var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7137 18.0032L2.63536 35.4114C1.78878 34.8329 1.28615 33.8705 1.29504 32.8452V3.16123C1.28615 2.13589 1.78878 1.17353 2.63536 0.594971L20.7137 18.0032Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0389 11.9226L20.7131 18.0032L2.63477 0.594958C2.70288 0.542166 2.77383 0.493052 2.84723 0.447846C3.80269 -0.131253 4.99614 -0.149948 5.9693 0.398809L27.0389 11.9226Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7058 18.0032C34.7176 19.1607 34.0886 20.2299 33.0713 20.782L27.0397 24.0839L20.7139 18.0032L27.0397 11.9226L33.0713 15.2244C34.0886 15.7766 34.7176 16.8457 34.7058 18.0032Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0389 24.0838L5.9693 35.6075C4.99399 36.1478 3.80507 36.1291 2.84723 35.5585C2.77383 35.5133 2.70288 35.4642 2.63477 35.4114L20.7132 18.0032L27.0389 24.0838Z",
    fill: "#F44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreIcon);
export default __webpack_public_path__ + "static/media/PlaystoreIcon.9a5f55d81a90da817b673cf37ab7e3f5.svg";
export { ForwardRef as ReactComponent };